<app-dynamic-form title="Category" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
